'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellRootContext } from './context/upsell-root.context';
import { upsellBodyRecipe } from './styles/upsell-body.styles';
import type { UpsellBodyPropsInterface } from './types/upsell-body.types';

/**
 * @since 10.0.0
 */
export const UpsellBody = forwardRef<HTMLDivElement, UpsellBodyPropsInterface>(
  (props: UpsellBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellRootContext);
    const styles = css(upsellBodyRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Body"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellBody.displayName = 'Upsell.Body';
